import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { NOTIF_ERROR, ERROR } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";

export const getPublicAdsById = (adsId) => () => {
    return ApiService.post(Path.PUBLIC_ADS + `/${adsId}`)
        .then((response) => {
            if (ERROR === response.data.status) {
                SideNotification((response.data.status).toLowerCase(), response.data.message)
            }
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const insertPublicDonation = (donation) => () => {
    return ApiService.post(Path.DONATE_INSERT, donation)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}